const initMobileSwipers = () => {
    const mobileSwipers = document.querySelectorAll('[data-swiper-mobile]');
    if (mobileSwipers.length) {
        mobileSwipers.forEach((mobileSwiper) => {
            

            const mobileSwiperWrapper = mobileSwiper.children[0];
            if (!mobileSwiperWrapper) return;

            const mobileSwiperSlides = mobileSwiperWrapper.querySelectorAll(':scope > *');
            if (!mobileSwiperSlides || !mobileSwiperSlides.length) return; 


            mobileSwiperWrapper.classList.add('swiper-wrapper');
            mobileSwiperSlides.forEach((slide) => slide.classList.add('swiper-slide'));
            
            // Add scrollbar
            const swiperScrollbar = document.createElement('div');
            swiperScrollbar.classList.add('swiper-scrollbar');
            mobileSwiper.append(swiperScrollbar);

            // Add pagination
            // const swiperPagination = document.createElement('div');
            // swiperPagination.classList.add('swiper-pagination');
            // mobileSwiper.append(swiperPagination);

            new Swiper(mobileSwiper, {
                direction: 'horizontal',
                slidesPerView: 1.15,
                autoHeight: true,
                spaceBetween: 10,
                // pagination: {
                //     el: ".swiper-pagination",
                // },
                scrollbar: {
                    el: '.swiper-scrollbar',
                    draggable: true,
                },
            });    
        });  
    }
}

const initTabs = () => {
    let tabs = document.querySelectorAll(".tab-link");
    let contents = document.querySelectorAll(".tab-content");

    tabs.forEach(tab => {
        tab.addEventListener("click", function () {
            let tabId = this.getAttribute("data-tab");

            tabs.forEach(t => t.classList.remove("active"));
            contents.forEach(c => c.classList.remove("active"));

            this.classList.add("active");
            document.getElementById(tabId).classList.add("active");
        });
    });
}

const initBtnPrint = () => {
    const $btnPrint = document.querySelector(".btn-print");
    if ($btnPrint) {
      $btnPrint.addEventListener("click", function (e) {
          e.preventDefault();
          window.print();
      });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    initTabs();
    initBtnPrint();

    if (window.innerWidth <= 768) {
        initMobileSwipers();
    }
});